import { createElement } from 'react';
import type { LogoProps } from './LogoType';
import { useTheme } from '@/assets/styles/themeMantine';

export const LogoMark = ({ theme = 'dark', size = 24 }: LogoProps) => {
  const mantineTheme = useTheme();
  let color, dotColor;
  switch (theme) {
    case 'dark':
      color = 'black';
      dotColor = mantineTheme.colors.custom[1];
      break;
    case 'brand':
      color = 'white';
      // eslint-disable-next-line no-restricted-syntax
      dotColor = '#FFCF60';
      break;
    default:
      color = 'white';
      dotColor = mantineTheme.other.mainColor.accent.normal;
  }

  return createElement(
    'svg',
    {
      fill: color,
      width: size,
      height: size,
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
    },
    createElement('path', {
      d: 'M14.379 5.11719C11.808 5.11719 9.59403 6.01719 7.79403 7.79319C5.99403 9.56919 5.08203 11.7862 5.08203 14.3782C5.08203 16.9732 5.99403 19.1872 7.79403 20.9632C9.59403 22.7392 11.808 23.6392 14.379 23.6392C16.971 23.6392 19.194 22.7392 20.982 20.9632C22.77 19.1872 23.676 16.9732 23.676 14.3782C23.676 11.7862 22.77 9.56919 20.982 7.79319C19.194 6.02019 16.971 5.11719 14.379 5.11719ZM18.108 18.1792C17.106 19.1812 15.852 19.6912 14.379 19.6912C12.909 19.6912 11.652 19.1842 10.65 18.1792C9.64803 17.1742 9.13803 15.8992 9.13803 14.3812C9.13803 12.8632 9.64503 11.5852 10.65 10.5832C11.652 9.58119 12.906 9.07119 14.379 9.07119C15.852 9.07119 17.106 9.57819 18.108 10.5832C19.11 11.5852 19.62 12.8632 19.62 14.3812C19.62 15.8962 19.11 17.1742 18.108 18.1792Z',
    }),
    createElement('path', {
      d: 'M3.30605 6.31278C4.96622 6.31278 6.31205 4.96695 6.31205 3.30678C6.31205 1.64661 4.96622 0.300781 3.30605 0.300781C1.64588 0.300781 0.300049 1.64661 0.300049 3.30678C0.300049 4.96695 1.64588 6.31278 3.30605 6.31278Z',
      fill: dotColor,
    })
  );
};
